export const TIMEZONE= {
        'DontShow': 'D',
        'Show':'S',
        'DST':'I'
    }

export const DATEFORMAT= {
   'MonthDay': 'M',
   'DayMonth':'D'
}    